import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { domain } from './Domain';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, KeyRound, ArrowLeft } from 'lucide-react';
import Header from './Header';
import '../css/Login.css';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [isPending, setIsPending] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusKind, setStatusKind] = useState('info');

    function validateForm() {
        return email.trim().length > 0;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsPending(true);
        setStatusMessage('Sending request…');
        setStatusKind('info');
        const form = e.target;
        const data = new FormData(form);
        const requestOptions = {
            method: 'POST',
            body: data,
        };
        fetch(`${domain}/accounts/password-reset`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                form.reset();
                setEmail('');
                const msg = data.message || 'Check your inbox for reset instructions.';
                setStatusMessage(msg);
                setStatusKind('success');
                setTimeout(() => {
                    setStatusMessage('');
                }, 5000);
                setIsPending(false);
            })
            .catch(() => {
                setStatusMessage('Something went wrong. Please try again.');
                setStatusKind('error');
                setIsPending(false);
            });
    };

    return (
        <>
            <Header />
            <div
                id="forgotPasswordForm"
                className="login-page animate__animated animate__fadeIn"
            >
                <div className="login-card">
                    <form onSubmit={handleSubmit} className="login-form" noValidate>
                        <div className="login-card-header">
                            <h1 className="login-title">Forgot password</h1>
                            <p className="login-subtitle">
                                Enter your username or email and we&apos;ll send reset
                                instructions.
                            </p>
                        </div>

                        <AnimatePresence>
                            {statusMessage && (
                                <motion.div
                                    key={statusMessage}
                                    initial={{ opacity: 0, y: -6 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -6 }}
                                    className={`login-alert ${
                                        statusKind === 'success'
                                            ? 'login-alert--success'
                                            : statusKind === 'error'
                                              ? 'login-alert--error'
                                              : 'login-alert--info'
                                    }`}
                                    role="status"
                                >
                                    {statusMessage}
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <div className="login-fields">
                            <label
                                htmlFor="forgot-username"
                                className="login-label"
                            >
                                Username or email
                            </label>
                            <div className="login-input-wrap">
                                <span className="login-input-icon" aria-hidden>
                                    <Mail size={18} strokeWidth={2} />
                                </span>
                                <input
                                    id="forgot-username"
                                    type="text"
                                    name="username"
                                    autoComplete="username"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Username or email address"
                                    className="login-input"
                                />
                            </div>

                            {isPending ? (
                                <button
                                    type="button"
                                    disabled
                                    className="login-submit login-submit--loading"
                                >
                                    <span className="login-submit-inner">
                                        Requesting reset instructions…
                                    </span>
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="login-submit"
                                    disabled={!validateForm()}
                                >
                                    <span className="login-submit-inner">
                                        <KeyRound size={18} strokeWidth={2} />
                                        Send reset link
                                    </span>
                                </button>
                            )}
                        </div>

                        <div className="login-register-hint">
                            <Link
                                to="/login"
                                className="login-link-primary login-back-link"
                            >
                                <ArrowLeft size={16} strokeWidth={2} />
                                Back to sign in
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}
